<style src="../assets/css/article.css" scoped></style>


<template>

<main class="page">
  <!-- MAIN CONTENT -->
  <div>
    <!-- Cover -->
    <section class="cover">
      <div class="coverMedia">
        <div class="coverBadge"><span class="dot"></span> Conseils adoption</div>
      </div>

      <div class="coverBody">
        <div class="breadcrumb">
          <a href="#">Blog</a>
          <span>›</span>
          <span>Conseils</span>
        </div>

        <h1 class="title">
          Adopter un chien : 7 questions à se poser avant de se lancer
        </h1>
        <p class="subtitle">
          Un guide clair pour faire le bon choix et préparer l’arrivée de votre futur compagnon,
          tout en respectant le rythme du refuge.
        </p>

        <div class="meta">
          <span class="pill">⏱ 6 min</span>
          <span class="pill">📅 14 janvier 2026</span>
          <span class="pill">✍️ Asso-Refuge</span>
        </div>
      </div>
    </section>

    <!-- Article -->
    <article class="article">
      <div class="toc">
        <h3>Sommaire</h3>
        <a href="#q1">1) Temps et disponibilité</a>
        <a href="#q2">2) Budget et organisation</a>
        <a href="#q3">3) Mode de vie</a>
        <a href="#q4">4) Enfants / autres animaux</a>
        <a href="#q5">5) Éducation et patience</a>
        <a href="#q6">6) Période d’adaptation</a>
        <a href="#q7">7) Le bon refuge / la bonne rencontre</a>
      </div>

      <p class="quote">
        Adopter, ce n’est pas “prendre un animal”. C’est accueillir un compagnon avec son histoire,
        ses besoins et son rythme. Le refuge est là pour vous guider.
      </p>

      <h2 id="q1">1) Temps et disponibilité</h2>
      <p>
        Un chien a besoin de présence, de sorties, et d’une routine stable. Avant d’adopter,
        posez-vous la question : <span class="hl">ai-je vraiment du temps au quotidien ?</span>
      </p>

      <h2 id="q2">2) Budget et organisation</h2>
      <p>
        Entre l’alimentation, le vétérinaire, les accessoires, et parfois l’éducation,
        l’adoption implique un budget. L’objectif n’est pas de “faire peur”,
        mais d’éviter les mauvaises surprises.
      </p>

      <h2 id="q3">3) Mode de vie</h2>
      <p>
        Appartement ou maison, ville ou campagne, sportif ou tranquille : il existe un chien
        adapté à votre rythme. Le refuge vous aide à faire matcher profil et réalité.
      </p>

      <h2 id="q4">4) Enfants / autres animaux</h2>
      <p>
        La compatibilité dépend du tempérament et de l’histoire de l’animal.
        Demandez toujours au refuge les retours et les tests effectués.
      </p>

      <h2 id="q5">5) Éducation et patience</h2>
      <p>
        Un chien de refuge peut avoir besoin de réapprendre certaines choses (propreté, solitude, codes).
        La clé : <span class="hl">patience + cohérence + douceur</span>.
      </p>

      <h2 id="q6">6) Période d’adaptation</h2>
      <p>
        Les premières semaines sont cruciales : laissez le temps au chien de comprendre son nouvel environnement.
        Évitez de tout lui imposer dès le premier jour.
      </p>

      <h2 id="q7">7) Le bon refuge / la bonne rencontre</h2>
      <p>
        Le refuge n’est pas “un magasin”. C’est une équipe qui connaît les animaux et votre projet d’adoption.
        Prenez le temps d’échanger, de poser vos questions et d’organiser une rencontre.
      </p>

      <div class="related">
        <h2 style="margin:0;">À lire aussi</h2>
        <div class="relatedGrid">
          <a class="rel" href="#">
            <div class="relThumb"></div>
            <div class="relBody">
              <div class="relTitle">Adopter un chat : les erreurs fréquentes à éviter</div>
              <div class="relMeta">Conseils • 5 min</div>
            </div>
          </a>

          <a class="rel" href="#">
            <div class="relThumb"></div>
            <div class="relBody">
              <div class="relTitle">Comment préparer son logement avant l’arrivée</div>
              <div class="relMeta">Guide • 4 min</div>
            </div>
          </a>

          <a class="rel" href="#">
            <div class="relThumb"></div>
            <div class="relBody">
              <div class="relTitle">Comprendre la période d’adaptation en refuge</div>
              <div class="relMeta">Éducation • 6 min</div>
            </div>
          </a>
        </div>
      </div>
    </article>
  </div>

  <!-- ASIDE -->
  <aside class="aside">
    <div class="card">
      <h3>Rechercher un animal</h3>
      <p>Accédez directement aux animaux disponibles dans les refuges partenaires.</p>
      <div class="ctaRow">
        <a class="linkBtn primary" href="#">Voir les animaux</a>
        <a class="linkBtn" href="#">Voir les refuges</a>
      </div>
    </div>

    <div class="card">
      <h3>Vous êtes un refuge ?</h3>
      <p>
        Asso-Refuge crée des sites <span class="hl">100% gratuits</span> (hébergement inclus, sans pub)
        pour aider les refuges à gagner en visibilité.
      </p>
      <div class="ctaRow">
        <a class="linkBtn primary" href="#">Devenir partenaire</a>
        <a class="linkBtn" href="#">Contact</a>
      </div>
    </div>
  </aside>
</main>


</template>